<script lang="ts" setup>
import { useRouter, useRoute } from 'vue-router';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { ref, computed, onMounted } from 'vue';
import { useModuleStore } from '@/store/moduleStore';
import axiosInstance from '@/plugins/axios';

const router = useRouter();
const route = useRoute();
const moduleStore = useModuleStore();

const translationId = computed(() => route.params.translation as string);
const languageCode = ref<string>('');

const goTo = (category: string) => {
    router.push({ name: 'EvaluationCategoryDetailView', params: {category: category} });
};

// Load translation to get language code
const loadTranslation = async () => {
    try {
        const response = await axiosInstance.get(`/translations/${translationId.value}`);
        languageCode.value = response.data.languageCode?.toLowerCase() || '';
    } catch (error) {
        console.error('Failed to load translation:', error);
    }
};

// Check if requirements should be shown
// EN and DE are always visible (AI Lab Admin base translations)
// For other languages (tenant-specific), only show if requirements module is active
const showRequirements = computed(() => {
    if (languageCode.value === 'en' || languageCode.value === 'de') {
        return true;
    }
    // For tenant languages, check if module is active
    return moduleStore.isModuleActive('requirements');
});

onMounted(() => {
    loadTranslation();
});

</script>

<template>
    <div>

            <div class="card-grid">
                <Card class="menuCard" @click="goTo('summaries')">
                <template #title>
                    Summaries
                </template>
                </Card>
                <Card class="menuCard" @click="goTo('justifications')">
                <template #title>
                    Justifications
                </template>
                </Card>
                <Card class="menuCard" @click="goTo('result')">
                <template #title>
                    Results
                </template>
                </Card>
                <Card v-if="showRequirements" class="menuCard" @click="goTo('requirements')">
                <template #title>
                    Requirements
                </template>
                </Card>
            </div>
    </div>
</template>